export const Logo = (
  <svg
    width="277"
    height="27"
    viewBox="0 0 277 27"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M151.124 17.9887L159.016 26L166.876 18.0222L174.719 25.9826L179.861 20.7637C181.38 19.2215 181.38 16.7219 179.861 15.1797L174.769 10.0109L166.876 2L151.124 17.9887Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M143.231 10.0109L138.139 15.1797C136.62 16.7219 136.62 19.2215 138.139 20.7637L143.265 25.9661L151.124 17.9887V2L143.231 10.0109Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M151.124 17.9887L159 9.99435L151.124 2V17.9887Z"
      fill="currentColor"
    />
    <mask
      id="mask0_6171_5885"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="151"
      y="2"
      width="8"
      height="16"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M151.124 17.9887L159 9.99435L151.124 2V17.9887Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_6171_5885)"></g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M260.71 8.68434H262.832C262.919 8.68434 262.964 8.58615 262.914 8.5162C262.874 8.46145 259.929 4.39435 259.929 4.39435H257.809C257.73 4.39435 257.672 4.48863 257.722 4.55771C257.794 4.65677 260.71 8.68434 260.71 8.68434Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M264.171 16.7877C264.171 16.7025 264.062 16.6434 263.991 16.7156C263.967 16.7399 263.041 17.6797 261.941 18.7945V10.7442H257.057V12.6307H259.888V20.8774C258.985 21.7937 258.291 22.498 258.291 22.498L259.63 23.8236L264.171 19.2168V16.7877Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M271.117 18.4229C273.336 15.5863 275.407 11.5209 276.129 5.85406H274.107C274.065 5.85406 274.03 5.88491 274.025 5.92662C273.433 10.1945 271.993 13.8423 269.735 16.8271C267.854 14.3815 266.187 10.9457 265.409 6.13734C265.402 6.0965 265.367 6.06652 265.327 6.06652L263.296 6.06522C264.153 11.7937 266.2 15.757 268.363 18.4568C267.905 18.9434 267.423 19.4092 266.914 19.8528C265.491 21.0906 264.108 21.9309 263.044 22.4731V24.5594C263.044 24.6637 263.151 24.7324 263.246 24.6894C264.485 24.125 266.3 23.1274 268.192 21.4964C268.695 21.0637 269.218 20.5697 269.748 20.0118C270.3 20.5697 270.846 21.0537 271.365 21.469C273.573 23.2313 275.65 24.0737 276.815 24.4443C276.907 24.4734 277 24.4043 277 24.3074V22.3063C275.661 21.8175 273.356 20.7165 271.117 18.4229Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M269.361 9.05162H271.39C271.468 9.05162 271.518 8.98601 271.489 8.90781C271.459 8.82048 269.857 4.33411 269.857 4.33411H267.827C267.75 4.33411 267.704 4.41318 267.726 4.47531C267.754 4.55265 269.361 9.05162 269.361 9.05162Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M237.31 13.4265H250.092V11.5426H237.31V13.4265Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M234.185 17.6243H238.2L235.653 24.4924C235.614 24.5819 235.672 24.6541 235.747 24.6541H251.887C251.962 24.6541 252.018 24.5819 251.98 24.4924L250.015 19.1767H248.078C248.003 19.1767 247.951 19.2488 247.976 19.317L249.253 22.7702H238.353L240.261 17.6243H253.219V15.743H234.185V17.6243Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M243.706 4.01166C243.668 4.01166 243.643 4.02991 243.643 4.02991C240.877 5.99459 237.682 8.04531 233.766 10.2576V12.3779C233.766 12.4357 233.835 12.5191 233.934 12.4669C237.743 10.3219 240.473 8.68485 243.706 6.49989C246.939 8.68485 249.668 10.3219 253.478 12.4669C253.577 12.5191 253.646 12.4357 253.646 12.3779V10.2576C249.73 8.04531 246.534 5.99459 243.768 4.02991C243.768 4.02991 243.744 4.01166 243.706 4.01166Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M223.232 12.7987H227.732V6.5462H223.232V12.7987ZM229.615 4.83133H217.792V6.5462H221.352V12.7987H217.272V14.514H221.352V25H223.233V14.514H227.733V24.7802H231.287V23.064H229.615V4.83133Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M196.146 21.9191H205.473V20.2038H196.146V21.9191Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M191.501 16.3091H193.897V12.2046H191.501V16.3091ZM191.501 10.6614H193.897V6.58911H191.501V10.6614ZM189.79 17.03C189.79 20.1487 189.538 22.5157 189.021 24.6133C188.966 24.808 189.025 24.8597 189.126 24.8597H190.842C191.414 21.9782 191.489 19.5878 191.499 17.8529H193.897V23.1852H192.194C192.111 23.1852 192.047 23.2391 192.091 23.3581L192.56 24.9001H195.604V4.87433H189.79V17.03Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M199.746 13.6097C200.181 13.107 200.602 12.5201 200.994 11.8262H204.04C204.45 12.5022 204.891 13.0918 205.347 13.6097H199.746ZM206.134 11.8262H208.431V10.2825H201.738C201.94 9.78936 202.122 9.2606 202.287 8.68753H208.011V7.14385H206.334C206.614 6.19018 206.943 5.06489 206.962 4.99972C206.996 4.88546 206.936 4.84157 206.862 4.84157H205.406L204.73 7.14385H202.672C202.863 6.25144 203.031 5.26301 203.183 4.15424C203.201 4.02563 203.132 4 203.047 4H201.389C201.219 5.17873 201.042 6.19452 200.815 7.14385H199.805L199.13 4.84157H197.673C197.6 4.84157 197.54 4.88546 197.573 4.99972C197.592 5.06489 197.922 6.19018 198.201 7.14385H196.568V8.68753H200.381C200.226 9.17501 199.998 9.74895 199.755 10.2825H196.148V11.8262H198.857C197.765 13.3807 196.598 14.0959 196.132 14.3813V16.1474C196.132 16.2361 196.202 16.3304 196.481 16.1722C196.987 15.8841 197.527 15.5587 198.075 15.1534H204.447L204.393 17.4648H199.362L199.439 16.0827C199.439 16.0232 199.395 15.9784 199.334 15.9784H197.725L197.564 18.9042C197.563 18.9637 197.607 19.0084 197.668 19.0084H206.347V23.182H202.435C202.353 23.182 202.288 23.2359 202.332 23.3549L202.801 24.8969H208.229V17.4648H206.104L206.174 14.4634C206.969 15.2042 207.775 15.7551 208.508 16.1722C208.786 16.3304 208.856 16.2361 208.856 16.1474V14.3813C208.391 14.0959 207.225 13.379 206.134 11.8262Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M218.986 19.0114C218.955 19.0353 217.358 20.2479 215.813 21.4219V10.2724H211.417V12.1589H213.944V22.8413C213.342 23.2988 212.933 23.609 212.933 23.609L213.966 24.9767L219.156 21.0343V19.0922C219.156 18.9992 219.053 18.9601 218.986 19.0114Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M214.189 8.58354H216.245C216.337 8.58354 216.374 8.48448 216.334 8.42278C216.296 8.36543 213.74 4.45126 213.74 4.45126H211.683C211.605 4.45126 211.549 4.5412 211.591 4.6068C211.634 4.67241 214.189 8.58354 214.189 8.58354Z"
      fill="currentColor"
    />
    <path d="M122 5V24.5" stroke="black" strokeOpacity="0.1" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M83.1477 5.15161H71.979V6.84032H75.3416V12.9968H71.4883V14.6851H75.3416V25.0094H77.1194V14.6851H81.3699V24.7932H84.7268V23.1037H83.1477V5.15161ZM77.1199 12.9966H81.3707V6.84014H77.1199V12.9966Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M51.6304 22.3619H60.8974V21.038H51.6304V22.3619Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M45.2083 17.1067C45.2083 20.2252 44.9647 22.5922 44.4636 24.6896C44.4107 24.8834 44.4674 24.9358 44.566 24.9358H46.227C46.7814 22.0545 46.8539 19.664 46.8635 17.9296H49.1851V23.261H47.5365C47.4563 23.261 47.3937 23.3158 47.4363 23.4346L47.8906 24.976H50.8384V4.95251H45.2083V17.1067ZM46.8648 16.3869H49.1849V12.2831H46.8648V16.3869ZM46.8648 10.7386H49.1849V6.66693H46.8648V10.7386Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M61.0347 11.9038H63.2589V10.3604H56.7782C56.9739 9.86714 57.15 9.33853 57.31 8.76583H62.8526V7.22208H61.2289C61.499 6.2685 61.8182 5.14336 61.837 5.07823C61.8689 4.96385 61.8109 4.91976 61.7399 4.91976H60.3292L59.6754 7.22208H57.6822C57.8679 6.32967 58.0302 5.34154 58.1771 4.23268C58.1944 4.104 58.1272 4.07858 58.0451 4.07858H56.4398C56.2756 5.25695 56.1037 6.27248 55.8839 7.22208H54.9059L54.2525 4.91976H52.8421C52.7707 4.91976 52.7124 4.96385 52.745 5.07823C52.7635 5.14336 53.0823 6.2685 53.3528 7.22208H51.7717V8.76583H55.4642C55.3141 9.25314 55.0931 9.82703 54.8576 10.3604H51.3653V11.9038H53.9885C52.9307 13.4578 51.8004 14.1731 51.3496 14.4587V16.224C51.3496 16.3134 51.4175 16.4075 51.6869 16.2495C52.1776 15.9615 52.7005 15.6358 53.2308 15.2303H59.4007L59.3485 17.5414H54.4773L54.5514 16.1597C54.5514 16.1001 54.5096 16.0552 54.4505 16.0552H52.8924L52.7358 18.9807C52.7358 19.0403 52.7777 19.0851 52.8367 19.0851H61.2412V23.2581H57.4531C57.3729 23.2581 57.3108 23.3125 57.3534 23.4308L57.8073 24.973H63.0632V17.5414H61.0056L61.0735 14.5405C61.8432 15.2812 62.6239 15.832 63.3334 16.2495C63.6031 16.4075 63.671 16.3134 63.671 16.224V14.4587C63.2202 14.1731 62.0918 13.4558 61.0347 11.9038ZM59.0069 11.9034C59.404 12.5794 59.8311 13.1688 60.2723 13.6867H54.8494C55.2703 13.1839 55.6782 12.5973 56.0576 11.9034H59.0069Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M72.8258 19.0879C72.7951 19.1125 71.2493 20.3243 69.7534 21.4979V10.3501H65.4961V12.2362H67.9428V22.9177C67.36 23.3748 66.9648 23.685 66.9648 23.685L67.9647 25.0528L72.9901 21.1106V19.1685C72.9901 19.0756 72.8911 19.0367 72.8258 19.0879Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M68.1833 8.6618H70.1746C70.2632 8.6618 70.2989 8.56251 70.2598 8.50095C70.2237 8.44376 67.7478 4.52979 67.7478 4.52979H65.7566C65.681 4.52979 65.6265 4.61994 65.6683 4.68587C65.7098 4.7514 68.1833 8.6618 68.1833 8.6618Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M88.5898 7.25341H102.971V5.36691H88.5898V7.25341Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M93.8094 14.3821H105V12.4956H86.5679V14.3821H91.6815C90.6252 17.2527 87.9748 24.4572 87.9568 24.5092C87.9276 24.5926 87.9806 24.655 88.0504 24.655H103.949C104.024 24.655 104.067 24.5779 104.04 24.5052C104.023 24.4599 101.67 18.0542 101.67 18.0542H99.6907C99.6155 18.0542 99.5707 18.1297 99.5956 18.1972C99.6209 18.2659 101.273 22.7685 101.273 22.7685H90.7319L93.8094 14.3821Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31.2421 22.1057C30.6003 22.7635 29.4551 23.5098 27.5755 23.5758C26.7065 23.6061 25.6915 23.6101 25.2271 23.6101H15.1281C18.8022 19.9154 22.0077 16.6932 22.3713 16.3279C22.7041 15.9926 23.4533 15.251 24.0995 14.6486C25.5183 13.3263 26.7953 13.0603 27.6984 13.0688C29.1137 13.0828 30.401 13.6809 31.3209 14.6467C33.289 16.7289 33.2426 20.0567 31.2421 22.1057ZM33.6618 12.2764C32.1524 10.6834 30.0493 9.6799 27.7109 9.67953C25.6897 9.67953 23.9494 10.4008 22.4301 11.6817C21.7679 12.2399 21.0732 12.908 20.1993 13.7868C19.7652 14.2232 7.1792 26.8645 7.1792 26.8645C7.8389 26.9619 8.74666 26.991 9.5557 26.9962C10.3134 27.001 24.7741 26.9999 25.3793 26.9999C26.5978 26.9999 27.3905 26.9984 28.2423 26.9338C30.1957 26.7863 32.0408 26.0447 33.5324 24.5281C36.8448 21.1612 36.8943 15.6967 33.6618 12.2764Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.4382 11.7646C11.9495 10.6307 10.2829 9.99709 8.39323 10C6.04058 10 3.9239 10.9931 2.40543 12.5686C-0.847761 15.9522 -0.797911 21.358 2.53526 24.6891C3.87369 26.0263 5.49473 26.754 7.22336 27L10.4844 23.7799C9.95725 23.7777 9.20052 23.7701 8.52916 23.7471C6.63771 23.6818 5.48541 22.9431 4.8395 22.2927C2.82683 20.2657 2.77985 16.9734 4.76024 14.9139C5.68624 13.958 6.98128 13.3664 8.40543 13.3529C9.29772 13.3493 10.5088 13.6131 11.877 14.7675C12.5305 15.3183 13.9812 16.6157 14.6174 17.2C14.6497 17.2296 14.6887 17.2321 14.7268 17.2004L16.9718 14.9712C17.0109 14.9329 17.0084 14.881 16.97 14.846C15.8902 13.8526 14.3595 12.4628 13.4382 11.7646Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28.988 7.79009C27.4228 3.25201 23.2085 0 18.251 0C12.565 0 7.85323 4.29188 7 9.88322C7.45723 9.80363 7.92678 9.76198 8.40647 9.76198C9.0742 9.76086 9.71331 9.84119 10.3278 9.99293C10.3401 9.99554 10.3521 9.99702 10.3636 10C11.1343 6.22508 14.3852 3.42123 18.251 3.42123C21.4712 3.42123 24.2957 5.41468 25.5692 8.23936C25.5892 8.28399 25.6232 8.2985 25.658 8.28883C26.6156 8.01882 27.7641 7.8615 28.8731 7.94555C28.9814 7.95373 29.0227 7.89125 28.988 7.79009Z"
      fill="currentColor"
    />
  </svg>
);
